theme.accordion = (function() {
  // Kein trapFocus mehr: Ein Eintrag hat oft nur den einen Knopf, die Falle
  // hielt den Fokus dort fest (WCAG 2.1.2). Escape klappt den offenen Eintrag zu.
  // Listener einmal pro Eintrag, nicht bei jedem Klick neu.
  function setOpen(item, open) {
    var btn = item.querySelector('.faq__list--item__button');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function accordionBody(e) { 
    let faqContainer = e.querySelectorAll('.faq__list--item__button');
    faqContainer.forEach(function (list) {
      let singleFaqItem = list.closest('.faq__list--item'),
          singleFaqItemBody = singleFaqItem.querySelector('.faq__body');

      singleFaqItem.addEventListener("keyup", (evt) => {
        if (evt.code === "Escape" && singleFaqItem.classList.contains("active")) {
          singleFaqItem.classList.remove("active");
          slideUp(singleFaqItemBody);
          setOpen(singleFaqItem, false);
          list.focus();
        }
      });

      list.addEventListener("click", function () {
          if (singleFaqItem.classList.contains("active")) {
            singleFaqItem.classList.remove("active");
            slideUp(singleFaqItemBody);
            setOpen(singleFaqItem, false);
          } else {
            singleFaqItem.classList.add("active");
            slideDown(singleFaqItemBody);
            setOpen(singleFaqItem, true);
            getSiblings(singleFaqItem).forEach(function (list) {
              let sibllingSingleAccordionBody = list.querySelector('.faq__body');
              list.classList.remove("active");
              slideUp(sibllingSingleAccordionBody);
              setOpen(list, false);
            });
          }
      });
      
    });
  }
  return accordionBody;
})();
